import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import HeaderLocation from '../components/Header';
import { getRandomFood } from '../helpers';

export default function ExploreFoods() {
  const [randomFood, setRandomFood] = useState();
  const handleGetFood = async () => {
    const result = await getRandomFood();
    if (result && result.meals && result.meals.length > 0) {
      setRandomFood(result.meals[0].idMeal);
    }
  };

  useEffect(() => {
    handleGetFood();
  }, []);

  return (
    <div className="page-wrapper-custom">
      <HeaderLocation title="Explorar Comidas" />
      <Container>
        <div className="text-center my-4">
          <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '2rem', color: 'var(--color-text)' }}>
            🥘 Opções de Pratos
          </h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '1rem', maxWidth: '500px', margin: '0 auto' }}>
            Como você gostaria de encontrar sua próxima receita culinária?
          </p>
        </div>

        <div className="d-flex flex-column gap-3 my-4 mx-auto" style={{ maxWidth: '650px' }}>
          <Link
            data-testid="explore-by-ingredient"
            to="/explorar/comidas/ingredientes"
            className="recipe-link"
            style={{ textDecoration: 'none' }}
          >
            <div
              className="search-bar-card p-4 d-flex align-items-center justify-content-between"
              style={{
                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                cursor: 'pointer',
                borderLeft: '5px solid var(--color-primary)'
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: '2.4rem' }}>🥦</span>
                <div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.3rem', margin: 0, color: 'var(--color-text)' }}>
                    Por Ingredientes
                  </h3>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem', margin: '4px 0 0 0' }}>
                    Escolha com base nos ingredientes que você já tem na geladeira ou despensa.
                  </p>
                </div>
              </div>
              <span style={{ color: 'var(--color-primary-dark)', fontWeight: 700, fontSize: '1.2rem' }}>&rarr;</span>
            </div>
          </Link>

          <Link
            data-testid="explore-by-area"
            to="/explorar/comidas/area"
            className="recipe-link"
            style={{ textDecoration: 'none' }}
          >
            <div
              className="search-bar-card p-4 d-flex align-items-center justify-content-between"
              style={{
                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                cursor: 'pointer',
                borderLeft: '5px solid var(--color-secondary)'
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: '2.4rem' }}>🌍</span>
                <div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.3rem', margin: 0, color: 'var(--color-text)' }}>
                    Por Local de Origem
                  </h3>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem', margin: '4px 0 0 0' }}>
                    Faça uma viagem gastronômica explorando pratos típicos ao redor do mundo.
                  </p>
                </div>
              </div>
              <span style={{ color: 'var(--color-secondary)', fontWeight: 700, fontSize: '1.2rem' }}>&rarr;</span>
            </div>
          </Link>

          <Link
            data-testid="explore-surprise"
            to={ `/comidas/${randomFood}` }
            onClick={ handleGetFood }
            className="recipe-link"
            style={{ textDecoration: 'none' }}
          >
            <div
              className="search-bar-card p-4 d-flex align-items-center justify-content-between"
              style={{
                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                cursor: 'pointer',
                borderLeft: '5px solid var(--color-accent-green)'
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: '2.4rem' }}>🎲</span>
                <div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.3rem', margin: 0, color: 'var(--color-text)' }}>
                    Me Surpreenda!
                  </h3>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem', margin: '4px 0 0 0' }}>
                    Deixe que nosso chef virtual escolha uma receita surpresa e deliciosa para você hoje.
                  </p>
                </div>
              </div>
              <span style={{ color: 'var(--color-accent-green)', fontWeight: 700, fontSize: '1.2rem' }}>&rarr;</span>
            </div>
          </Link>
        </div>
      </Container>
      <Footer className="footer orange" />
    </div>
  );
}
